const checkForThemes = (navOption, selectedCouncil) => {
  if (navOption === "/themes") {
    return selectedCouncil?.themes_connected;
  }
  return true;
};
export default checkForThemes;
